const modes = {
  all: {
    label: "列表循环",
    paths: '<path d="m17 2 4 4-4 4M3 11V8a2 2 0 0 1 2-2h16M7 22l-4-4 4-4m14-1v3a2 2 0 0 1-2 2H3"/>',
  },
  one: {
    label: "单曲循环",
    paths: '<path d="m17 2 4 4-4 4M3 11V8a2 2 0 0 1 2-2h16M7 22l-4-4 4-4m14-1v3a2 2 0 0 1-2 2H3M11 10l1-1v6"/>',
  },
  shuffle: {
    label: "随机播放",
    paths: '<path d="m17 3 4 4-4 4M3 7h3c3 0 4.5 5 6 7s3 3 6 3h3m-4-4 4 4-4 4M3 17h3c2 0 3.5-2 4.5-4M13.5 11C14.5 9 16 7 18 7h3"/>',
  },
};

export function playbackModeLabel(mode) {
  return modes[mode]?.label || modes.all.label;
}

export function playbackModeMarkup(mode) {
  const current = modes[mode] || modes.all;
  return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${current.paths}</svg><span>${current.label}</span>`;
}

export function playIconMarkup() {
  return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m8 5 11 7-11 7z"/></svg>';
}
